import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;
import Vue from 'vue'
import Page from './pages/merchant/merchatCenter/noveltyManger/noveltOprae.vue'
createPage(Page)